import React, {Fragment, useEffect, useLayoutEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { satc_customers } from "Constants/TableColumns";
import { Grid } from "@material-ui/core";
import RemoteTable from "../../../../Components/RemoteTable/RemoteTable";
import Translator from "Languages/Utility/Translator";
import { getAccountGroupAgent } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import Search from "Assets/svg/icon/search.svg";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import { useTranslation } from 'react-i18next';
import showNotify from "Helpers/Notify";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

export default function CustomersTable() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { allGroupAgents, pagination } = useSelector((state) => ({
    allGroupAgents: state.saAccounts.allGroupAgents,
    pagination: state.saAccounts.pagination
  }));
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    (async() => {
      await getData();
    })()
  },[])

  const setValue = (name, value) => {
   setSearch(value);
  };

  const onSearch = async (e) => {
    e.preventDefault();
    await getData({Name: search});
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearch("");
    await getData();
  }

  const getData = async (dataSearch = null) => {
    try{
      setLoading(true);
      let params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: sizePerPage,
        Page: 1,
        ...dataSearch
      };
      dispatch(getAccountGroupAgent(params))
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch {
      showNotify({
        text: t('noData2Display'),
        customClass:"error"
      })
    }
  }

  useEffect(() => {
    setTblData(allGroupAgents);
    setSizePerPage(pagination.Limit)
    setCurrentPage(pagination.Page)
    setTotal(pagination.Total)
  },[allGroupAgents])

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupAKey"),
          KeyUser: read("userAKey"),
          Limit: sizePerPage,
          Page: page,
        };
        await dispatch(getAccountGroupAgent(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  }

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2}>
        <Grid item lg={4} md={6} sm={8} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={search}
            label={<Translator id="nameSearch" />}
            placeholder={t('nameSearch')}
            icon={<ReactSVG src={Search} />}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
            className="searchInput"
          />
        </Grid>
        <Grid item xs={12}>
          <RemoteTable
            data={tblData}
            columns={satc_customers}
            loading={loading}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
            title={<Translator id="customerslist" />}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}
